/* eslint-disable */
<template>
  <div v-resize="handleResize">
    <Header />
    <v-card-text>
      <v-form v-if="showFilter" app temporary id="filterMenu">
        <div class="recherche-title">
          <div class="d-flex justify-space-between">
            <div class="title-h4">{{ GetTrad(85) }}</div>
            <v-btn @click.stop="showFilter = !showFilter" elevation="2" icon large>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-container>

          <v-row id="recherchebar">
            <v-col cols="12">

              <v-text-field v-model="localisation"
                            :label="GetTrad(111)"
                            flat
                            hide-details
                            clearable
                            clear-icon="mdi-close-circle-outline"></v-text-field>

            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <div class="font-weight-medium">{{ GetTrad(90) }}</div><br />
              <v-autocomplete :placeholder="GetTrad(114)" :menu-props="{closeOnContentClick:true}" ref="SecteurActivite" :items="listeSecteursActivites" name="pointeur" item-text="name" item-key="id" v-model="secteurActiviteSelection" solo chips multiple return-object>
                <template v-slot:selection="data">
                  <v-chip v-bind="data.attrs"
                          :input-value="data.selected"
                          close
                          @click="data.select"
                          @click:close="supprimerSecteurActivite(data.item.id)">
                    <v-avatar left>
                      <v-img :src="data.item.icone"></v-img>
                    </v-avatar>
                    {{ data.item.name }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template>
                    <v-list-item-avatar>
                      <img :src="data.item.icone">
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-html="data.item.name"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </template>
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-title>
                      {{ GetTrad(115) }}
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>

            </v-col>
            <v-col>
              <div class="font-weight-medium">{{ GetTrad(89) }}</div>  <br />
              <v-autocomplete :placeholder="GetTrad(114)" :menu-props="{closeOnContentClick:true}" ref="MarcheApplication" selectable selection-type="independent" :items="listeMarchesApplications" name="name" item-text="name" item-key="id" v-model="marcheApplicationSelection" solo chips multiple return-object>
                <template v-slot:selection="data">
                  <v-chip v-bind="data.attrs"
                          class="max-width-chip"
                          :input-value="data.selected"
                          close
                          @click="data.select"
                          @click:close="supprimerMarcheApplication(data.item.id)">
                    {{ data.item.name }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template>
                    <v-list-item-content>
                      <v-list-item-title v-html="data.item.name"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </template>
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-title>
                      {{ GetTrad(115) }}
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>

            </v-col>
          </v-row>

          <v-divider></v-divider>
          <v-row>
            <v-col>

              <div class="font-weight-medium">{{ GetTrad(110) }}</div>

            </v-col>
          </v-row>
          <v-row>
            <v-col>

              <v-autocomplete :placeholder="GetTrad(114)" :menu-props="{closeOnContentClick:true}" ref="pays" :items="listePays" name="pointeur" item-text="name" item-key="id" v-model="paysSelection" solo chips multiple return-object>
                <template v-slot:selection="data">
                  <v-chip v-bind="data.attrs"
                          :input-value="data.selected"
                          close
                          @click="data.select"
                          @click:close="supprimerPays(data.item.id)">
                    {{ data.item.name }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template>
                    <v-list-item-content>
                      <v-list-item-title v-html="data.item.name"></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </template>
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-title>
                      {{ GetTrad(115) }}
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>

            </v-col>
          </v-row>
        </v-container>
        <div class="text-center">
          <v-btn class="bouton-validation" tile @click.stop="filter = !filter" @click="showFilter = !showFilter" color="primary" ref="btnValid">
            {{ GetTrad(88) }} <v-icon right>mdi-chevron-right</v-icon>
          </v-btn>
        </div>

      </v-form>
    </v-card-text>
    <MoreInfo :cas="casSelectionne" :estAffiche="showMoreInfo" @fermer="fermerMoreInfo" @afficher="afficherMoreInfo"></MoreInfo>
    <v-main id="scrollingTarget">
      <v-container fluid>
        <v-row v-if="!showFilter" align-content="center">
          <v-col cols="6" sm="3" md="2" xl="1" align-self="center">
            <v-btn class="ma-2" tile @click.stop="showFilter = !showFilter" id="btnFiltrer" :small="window.width < 600">
              <v-icon left>mdi-filter</v-icon> {{ GetTrad(85) }}
            </v-btn>
          </v-col>
          <v-col calss="nbresult" cols="4" sm="4" md="1" xl="1" align-self="center">
            {{NbResult}} {{ GetTrad(86) }}

          </v-col>
          <v-col cols="6" md="3" xl="4" align-self="center" id="titreXS" class="d-sm-none" order="first">
            <strong>{{ GetTrad(102) }}</strong>
          </v-col>
          <v-col cols="6" md="3" xl="4" align-self="center" id="Note">
            {{ GetTrad(103) }}
          </v-col>
        </v-row>
        <v-row v-if="!showFilter" id="filtresEnCours" class="ma-2" style="max-width:50%">
          <template v-if="!marcheApplicationSelection.length && !secteurActiviteSelection.length && !paysSelection.length && !localisation">
            <div class="body-2">{{ GetTrad(92) }}</div>
          </template>
          <template v-else>
            <v-chip v-for="filtre in marcheApplicationSelection" :key="filtre.id" class="max-width-chip" close @click:close="supprimerMarcheApplication(filtre.id)">
              {{ filtre.name }}
            </v-chip>
            <v-chip v-for="filtre in secteurActiviteSelection" :key="filtre.id" class="max-width-chip" close @click:close="supprimerSecteurActivite(filtre.id)">
              {{ filtre.name }}
            </v-chip>
            <v-chip v-for="filtre in paysSelection" :key="filtre.id" class="max-width-chip" close @click:close="supprimerPays(filtre.id)">
              {{ filtre.name }}
            </v-chip>
          </template>
          <template v-if="localisation">
            <v-chip class="ma-2" close @click:close="viderLocalisation()">{{this.localisation}}</v-chip>
          </template>
        </v-row>
        <v-row>
          <v-col id="colCas" cols="12" lg="6" md="6" xs="12">
            <v-row dense>
              <v-col v-if="!showFilter" v-for="cas in this.GetCasUtilisationSansDeleguation"
                     :key="cas.Id"
                     xs="12" lg="4" md="6">
                <CasUtilisation :cas="cas" @selectionnerCas="afficherMoreInfo"></CasUtilisation>
              </v-col>
            </v-row>
          </v-col>
          <v-col id="colMap" cols="12" lg="6" md="6" xs="12">
            <div v-if="!showFilter" align-content="center">
              <v-tooltip bottom v-model="showCopiedH">
                <template #activator={}>
                  <v-btn color="blue-grey"
                         class="ma-2 white--text" @click="getShareFilterLink">
                    {{ GetTrad(118) }}
                    <v-icon right
                            dark>
                      mdi-share
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ GetTrad(119) }}</span>
              </v-tooltip>
            </div>
            <MyMap :cas="this.GetCasUtilisation" @selectionnerCas="afficherMoreInfo" @filtrerCas="filtrerCasParLocation"></MyMap>

          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <Footer></Footer>
    <v-overlay :value= "overlay" >
      <v-progress-circular indeterminate
                           size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
  import Header from '@/components/Header'
  import CasUtilisation from '@/components/CasUtilisation'
  import MyMap from '@/components/Map'
  import MoreInfo from '@/components/MoreInfo'
  import Footer from '@/components/Footer'

  import { mapState, mapGetters, mapActions } from 'vuex'

  export default {
    name: 'Home',
    components: {
      Header,
      CasUtilisation,
      MyMap,
      MoreInfo,
      Footer
    },
    data() {
      return {
        overlay:false,
        filter: null,
        nbResult: 0,
        showFilter: true,
        marcheApplicationSelection: [],
        secteurActiviteSelection: [],
        paysSelection: [],
        showMoreInfo: false,
        casSelectionne: {},
        localisation: '',
        showCopiedH: false,
        paramGet: {},
        window: { width: window.innerWidth, height: window.innerHeight },
				filtreUrl: false
      }
    },
    async created() {
			this.overlay = true
      this.chargerTraductions(this.Langue)
      window.addEventListener('resize', this.handleResize)
      this.handleResize();
			this.paramGet = this.getParamsFromTopUrl()
			if (this.paramGet.casid != null) {

				const response = await this.chargerCasUtilisationUnique(this.paramGet.casid)
				this.casSelectionne = response.data

				if (Object.keys(this.casSelectionne).length != 0) {
						this.afficherMoreInfo(this.casSelectionne); 
				}
			}
		},
    destroyed() {
      window.removeEventListener('resize', this.handleResize)
    },
    computed: {
      ...mapState({
        listeMarchesApplications: state => state.MarchesApplications,
        listeSecteursActivites: state => state.SecteursActivites,
        listePays: state => state.Pays,
        listeCasUtilisations: state => state.CasUtilisations,
        listeTraductions: state => state.Traduction.Traductions,
        langue: state => state.Traduction.Langue,
        casUrl: state => state.CasUtilisation,
      }),
			...mapGetters({ GetCasUtilisation: 'GET_CAS_UTILISATION', GetCasUtilisationSansDeleguation: 'GET_CAS_UTILISATION_SANS_DELEGUATION', GetTrad: 'Traduction/GET_BY_ID', GetCasUtilisationUnique: 'GET_CAS_UTILISATION_UNIQUE', GetPays: 'GET_PAYS' }),
      NbResult: function () {
        return this.GetCasUtilisationSansDeleguation.length
      }
    },
    methods: {
      ...mapActions({
				chargerCasUtilisationUnique: 'ChargerCasUtilisationById',
        chargerMarcheApplication: 'ChargerMarcheApplication',
        chargerSecteurActivite: 'ChargerSecteurActivite',
        chargerPays: 'ChargerPays',
				chargerCasUtilisation: 'ChargerCasUtilisation',
				chargerCasUtilisationFiltrer: 'ChargerCasUtilisationFiltrer',
        filtrerCasParLocation: 'FiltrerParLocation',
        chargerTraductions: 'Traduction/ChargerTraductions',
        filtrer: 'Filtrer'
      }),
    
			getShareFilterLink() {
        let getVariablePays = "";
        this.paysSelection.forEach((value) => {
					if (getVariablePays == "") {
						getVariablePays = "?pays=" + value.id
          } else {
						getVariablePays += ";" + value.id
					}
        });
        let getVariableMarcheApplication = "";
				this.marcheApplicationSelection.forEach((value) => {
					if (getVariableMarcheApplication == "" && getVariablePays == "") {
						getVariableMarcheApplication = "?marcheapplication=" + value.id
          }
					else if (getVariableMarcheApplication == "" && getVariablePays != "") {
						getVariableMarcheApplication = "&marcheapplication=" + value.id
					}
          else {
						getVariableMarcheApplication += ";" + value.id
					}
        });
        let getSecteurActivite = "";
				this.secteurActiviteSelection.forEach((value) => {
					if (getSecteurActivite == "" && getVariableMarcheApplication == "" && getVariablePays == "") {
						getSecteurActivite = "?secteuractivite=" + value.id
          }
					else if (getSecteurActivite == "" && ( getVariableMarcheApplication != "" || getVariablePays != "") ) {
						getSecteurActivite = "&secteuractivite=" + value.id
					}
          else {
						getSecteurActivite += ";" + value.id
					}
        });
        let motsClefs = "";
        if (this.localisation != "") {
          if (getSecteurActivite == "" && getVariableMarcheApplication == "" && getVariablePays == "") {
						motsClefs = "?motsclefs=" + this.localisation
          } else {
						motsClefs = "&motsclefs=" + this.localisation
          }
					motsClefs = motsClefs.replace(" ","%20")
				}

				let getVariable = getVariablePays + getVariableMarcheApplication + getSecteurActivite + motsClefs
				navigator.clipboard.writeText((window.location.href.split('?')[0] + getVariable));
				this.showCopiedH = true;
				setTimeout(() => {
					this.showCopiedH = false
				}, 1500)
      },

      supprimerMarcheApplication(id) {
        this.marcheApplicationSelection = this.marcheApplicationSelection.filter(x => x.id != id)
        this.filter = !this.filter
      },
      supprimerSecteurActivite(id) {
        this.secteurActiviteSelection = this.secteurActiviteSelection.filter(x => x.id != id)
        this.filter = !this.filter
      },
      supprimerPays(id) {
        this.paysSelection = this.paysSelection.filter(x => x.id != id)
        this.filter = !this.filter
      },
      viderLocalisation() {
        this.localisation = undefined
      },
			afficherMoreInfo(cas) {
        this.casSelectionne = cas
        this.showMoreInfo = true
      },
      fermerMoreInfo() {
        this.casSelectionne = {}
        this.showMoreInfo = false
      },
      handleResize() {
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
        if (this.window.width < 600) {
          this.extended = false
        } else {
          this.extended = true
        }
      },
      getIconeSecteurActivite(id) {
        return this.listeSecteursActivites.find(s => s.id == id).icone
      },
      getParamsFromTopUrl() {
        const uri = window.location.href.split('?');
				let result = {};
				if (uri.length == 2) {
					let vars = uri[1].split('&');
					
					let tmp = '';
					vars.forEach(function (v) {
						tmp = v.split('=');
						if (tmp.length == 2)
							result[tmp[0]] = tmp[1];
					});
        }
        return result;
			}
    },
    async mounted() {
			parent.postMessage({ width: 100, height: document.body.scrollHeight }, process.env.VUE_APP_TARGET_ORIGIN.split(','));
			await this.chargerMarcheApplication(this.langue)
			await this.chargerSecteurActivite(this.langue)
			await this.chargerPays(this.langue)
      this.filtreUrl = false

			if (this.paramGet.pays != null) {
				this.filtreUrl = true
				let idPaysUrl = this.paramGet.pays.split("%3B")
        this.paysSelection = this.listePays.filter(pays => idPaysUrl.includes(pays.id))
      }

			if (this.paramGet.secteuractivite != null) {
				this.filtreUrl = true
				let idSecteuractiviteUrl = this.paramGet.secteuractivite.split("%3B")
				this.secteurActiviteSelection = this.listeSecteursActivites.filter(sa => idSecteuractiviteUrl.includes(sa.id))
      }

			if (this.paramGet.marcheapplication != null) {
				this.filtreUrl = true
				let idMarcheapplicationUrl = this.paramGet.marcheapplication.split("%3B")
				this.marcheApplicationSelection = this.listeMarchesApplications.filter(ma => idMarcheapplicationUrl.includes(ma.id))
      }

			if (this.paramGet.motsclefs != null) {

        this.filtreUrl = true
				this.localisation = this.paramGet.motsclefs
      }

			if (this.filtreUrl) {
				this.filter = !this.filter
				this.showFilter = false
			}
			else {
				await this.chargerCasUtilisation(this.langue)
			}
			this.overlay = false
    },
    watch: {
      filter: async function () {
				if (this.filtreUrl == true) {
					await this.chargerCasUtilisationFiltrer({
						selectedMarchesApplications: this.marcheApplicationSelection.map(marche => marche.id),
						selectedSecteursActivites: this.secteurActiviteSelection.map(secteur => secteur.id),
						selectedPays: this.paysSelection.map(pays => pays.id),
						lang: this.langue
					})
				}
        this.filtrer({ selectedMarchesApplications: this.marcheApplicationSelection, selectedSecteursActivites: this.secteurActiviteSelection, selectedPays: this.paysSelection, localisation: this.localisation })
      },
      localisation: function (val) {
        this.filtrer({ selectedMarchesApplications: this.marcheApplicationSelection, selectedSecteursActivites: this.secteurActiviteSelection, selectedPays: this.paysSelection, localisation: val })
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @font-face {
    font-family: 'tgl_0-1451_engschriftregular';
    src: url('../assets/Fonts/tgl_0-1451eng-webfont.woff2') format('woff2'), url('../assets/Fonts/tgl_0-1451eng-webfont.woff') format('woff');
    font-weight: normal;
    font-style: normal;
  }
	.v-autocomplete:not(.v-input--is-focused).v-select--chips input {
		max-height: 25px !important;
	}

  .title-h4 {
    color: forestgreen;
    font-size: 25px;
  }

  .font-weight-medium {
    margin-top: 10px;
    margin-bottom: -25px !important;
    font-size: 17px !important;
  }

  .recherche-title {
    margin-bottom: 5px;
  }

  .bouton-validation {
    margin-top: 30px;
  }

  .bouton-quitter {
    text-align: right;
  }

  .v-autocomplete {
    margin-top: 20px !important;
  }

  .v-toolbar__title {
    font-family: 'tgl_0-1451_engschriftregular';
    font-size: 32px;
  }

  .max-width-chip.v-chip {
    max-width: 280px;
    margin-right : 2px;
  }

  .max-width-chip .v-chip__content {
    line-height: 32px;
    padding-right: 30px !important;
    display: inline-block !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
  }

  .max-width-chip .v-chip__close {
    position: absolute;
    top: 7px;
    right: 5px;
    width: 24px;
  }


  .v-toolbar__extension {
    font-family: 'tgl_0-1451_engschriftregular';
    font-size: 20px;
    margin-left: 180px;
  }

  #filtresEnCours {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }

  #colMap {
    padding-top: 20px !important;
  }


  #filterMenu {
    margin-top: 150px;
    padding-right: 6%;
    padding-left: 6%;
    width: 50% !important;
  }

  .v-treeview-node__label {
    white-space: normal !important;
  }


  .v-treeview-node__root {
    min-height: 30px;
  }


  .v-main {
    padding-bottom: 100px !important;
  }

  #titreXS {
    word-break: break-word;
    line-height: normal;
  }

  #Note {
    font-family: 'Muli', sans-serif;
    font-weight: 400;
    font-size: 22px !important;
    color: #0093c8;
    word-break: break-word;
    line-height: normal;
  }

  #scrollingTarget {
    margin-top: 25px;
  }

  .v-main {
    padding-bottom: 50px;
  }

  @media only screen and (max-width:1400px) {
    #filterMenu {
      width: 50% !important;
    }

    #Note {
      font-size: 14px !important;
    }
  }

  @media only screen and (max-width:800px) {


    #colCas {
      order: 2;
    }

    #colMap {
      order: 1;
    }

    #Note {
      /*display:none;*/
      order: -1;
    }

    #filterMenu {
      margin-top: 120px;
      width: 100% !important;
    }

    #Terms {
      position: initial !important;
    }

    .max-width-chip.v-chip {
      max-width: 210px;
    }
  }

  @media only screen and (min-width:1000px) {
    #colMap {
      position: fixed;
      right: 0;
      top: 120px;
    }
  }
</style>

